module.exports = __webpack_public_path__ + "static/media/meal.8c773587.jpg";